const isProd = process.env.NODE_ENV === 'production';

const Config = {
    host: isProd
        ? "https://apisbahiol.folustecno.com/Bahiol-market/api/"
        : "http://localhost:8090/Bahiol-market/api/",
    whatsapp: "3204720783",
};

export default (Config)